import { render } from "./Simple.vue?vue&type=template&id=06d781dc"
import script from "./Simple.vue?vue&type=script&lang=js"
export * from "./Simple.vue?vue&type=script&lang=js"

import "./Simple.vue?vue&type=style&index=0&id=06d781dc&lang=scss"

import exportComponent from "../../../../../DIARC/pixonanimation.az/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__